// VignetteOverlay.jsx — 16:9 output-frame overlay (ticket 03 extraction).

import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import { MAP_OVERLAY_Z } from './mapEditorConstants';

// rerender-memo: parent (MapEditorModalInner) re-renders on every vertex placed/DTG scrub —
// memoized like ContextPanel/MapDrawToolbar. `onFrame` is already useCallback-stable.
const VignetteOverlay = React.memo(function VignetteOverlay({ onFrame }) {
    const containerRef = useRef(null);
    const [frame, setFrame] = useState(null);
    useEffect(() => {
        const el = containerRef.current;
        if (!el) return;
        const update = () => {
            const { width, height } = el.getBoundingClientRect();
            const frameW = Math.min(width, (height * 16) / 9);
            const frameH = frameW * (9 / 16);
            const rect = { left: (width - frameW) / 2, top: (height - frameH) / 2, width: frameW, height: frameH };
            setFrame(rect);
            onFrame?.(rect);
        };
        update();
        const ro = new ResizeObserver(update);
        ro.observe(el);
        return () => ro.disconnect();
    }, [onFrame]);
    return (
        <Box ref={containerRef} aria-hidden sx={{ position: 'absolute', inset: 0, zIndex: MAP_OVERLAY_Z.VIGNETTE, pointerEvents: 'none', overflow: 'hidden' }}>
            {frame && (
                <Box sx={{
                    position: 'absolute', left: frame.left, top: frame.top, width: frame.width, height: frame.height,
                    outline: '9999px solid rgba(0,0,0,0.45)', border: '1.5px dashed rgba(255,255,255,0.6)'
                }}>
                    <Box sx={{
                        position: 'absolute', bottom: 6, left: '50%', transform: 'translateX(-50%)',
                        color: 'rgba(255,255,255,0.5)', fontSize: 10, letterSpacing: 1, textTransform: 'uppercase', whiteSpace: 'nowrap'
                    }}>
                        16:9 output frame
                    </Box>
                </Box>
            )}
        </Box>
    );
});

export default VignetteOverlay;
